import {
  fetchRecoverUserReplyTemplate,
  type TRecoverUserReplyTemplateResponse,
  type TRecoverUserReplyTemplateRequest,
} from '../../repositories/chats/v1/recover-user-reply-template';

import type { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

export async function recoverUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TRecoverUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TRecoverUserReplyTemplateResponse> =
      await fetchRecoverUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw new Error((response as IErrorResponseSchema)?.message);
    }

    return response;
  } catch (e) {
    logger.error(e, {
      description: 'Ошибка восстановления шаблона ответа',
    });

    throw e;
  }
}
